import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Astăzi',
    [filter_yesterday]: 'Ieri',
    [filter_this_week]: 'Săptămâna aceasta',
    [filter_last_week]: 'Săptămâna trecută',
    [filter_this_month]: 'Luna aceasta',
    [filter_last_month]: 'Luna trecută',
    [filter_last_30_days]: 'Ultimele 30 de zile',
    [filter_all]: 'Toate',
  },
};
